declare namespace $ {

	type $mol_view__sub_shm_ba_mention_stats_task_list_head_1 = $mol_type_enforce<
		ReturnType< $shm_ba_mention_stats_task_list_head['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_mention_stats_task_list_head extends $shm_list_head {
		controls( ): readonly(any)[]
		search_showed( ): boolean
		Controls( ): $mol_view
	}
	
}

//# sourceMappingURL=head.view.tree.d.ts.map